import * as fromDistrictReducer from './district.reducer';
import {createSelector} from '@ngrx/store';
import {AppState} from "../../../../index";

export const currentState = (state: AppState) => (state[fromDistrictReducer.districtsFeatureKey]);

export const selectAllDistricts = createSelector(currentState, fromDistrictReducer.selectAll);

export const selectLDistrictsLoadingState = createSelector(currentState, fromDistrictReducer.getLoading);
